import type { FC } from 'react';
import type React from 'react';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import { SimpleTreeView } from '@mui/x-tree-view';

import type { GroupedCodingResult } from 'src/types/dashboard';

import OpenCommentsFilter from '../Filter';
import renderTree from '../renderTree';
import type { OpenCommentFilter } from '../types';

interface HRQSCommentsWidgetContentProps {
  resultsWithComparison: GroupedCodingResult[];
  highestTotal: number;
  filter: OpenCommentFilter;
  setFilter: React.Dispatch<React.SetStateAction<OpenCommentFilter>>;
  showTranslationToggle?: boolean;
}

const HRQSCommentsWidgetContent: FC<HRQSCommentsWidgetContentProps> = ({
  resultsWithComparison,
  highestTotal,
  filter,
  setFilter,
  showTranslationToggle = true,
}) => (
  <>
    <OpenCommentsFilter
      setOpenCommentFilter={setFilter}
      openCommentFilter={filter}
      withoutRelevance
    />
    <SimpleTreeView
      slots={{
        expandIcon: () => <FaPlusCircle style={{ marginRight: '0.5rem' }} />,
        collapseIcon: () => <FaMinusCircle style={{ marginRight: '0.5rem' }} />,
      }}
    >
      {resultsWithComparison.map((category) =>
        renderTree(
          category,
          1,
          highestTotal,
          '',
          filter,
          'hrqs',
          showTranslationToggle,
        ),
      )}
    </SimpleTreeView>
  </>
);

export default HRQSCommentsWidgetContent;
